export enum Spacings {
    xSmall = '8px',
    small = '16px',
    medium = '24px',
    large = '32px',
    xLarge = '64px',
}
